<template>
    <NuxtLayout>
        <NuxtPage :key="previewTimestamp" />
    </NuxtLayout>
    <MockModeIndicator v-if="isDev" />
</template>

<script setup>
    const { previewTimestamp } = usePreview()

    const isDev = useRuntimeConfig().public.SSR_ENVIRONMENT !== 'lambda'
</script>
